import React, { useEffect, useState, useContext } from "react";
import { MdOutlineAddShoppingCart } from 'react-icons/md';
import { useNavigate } from "react-router-dom";
import ReactDOM from "react-dom";
import BusinessCover from "components/mainBusiness/BusinessCover";
import Hashtags from "components/mainBusiness/Hashtags";
import Products from "components/mainBusiness/Products";
import PaginatedItems from "components/common/Pagination";
import Formatter from "hoc/Formatter";
import CreateProduct from "components/createModal/CreateProduct";
import Slider from "components/mainBusiness/Slider";
import SingleProduct from "components/mainBusiness/SingleProduct";
import { connection } from "utils/apiConnection.ts";
import { useParams } from "react-router";
import ModalCustomerMessages from "components/mainBusiness/ModalCustomerMessages";
import ModalContact from "components/mainBusiness/ModalContact";
import ModalShare from "components/mainBusiness/ModalShare";
import ModalPoint from "components/mainBusiness/ModalPoint";
import Loader from "utils/Loader";
import BusinessContext from "context/BusinessContext";
import Swal from "sweetalert2";
import Container from "components/LogIn/Container";
import WithAuthentication from "Authentication/AuthenticationContext.ts";

const MainBusiness = ({ itemsPerPage }) => {
  const params = useParams();
  const auth = useContext(WithAuthentication);

  const { products, setProducts, setSpace, bpid, setBusinessC } =
    useContext(BusinessContext);
  const [business, setBusiness] = useState({
    id: "",
    title: "",
    shop_suffix: "",
    address_text: "",
    coordinates: "",
    about_us: "",
    mobile: "",
    tell: "",
    cover_img_id: "",
    logo_img_id: "",
    current_coin: "",
    coin_total_deposite: "",
    coin_total_withdraw: "",
    cc_count: "",
    other_params:
      '{"socialMedia":[{"nameField":"","selectField":"-1"},{"nameField":"","selectField":"-1"}]}',
    muid: "",
    mtm: "",
    upuid: "",
    uptm: "",
    coverAddress: "",
    logoAddress: "",
    rate: "",
    customerMessages: [
      {
        id: "",
        title: "",
        description: "",
        mtm: "",
        rate: "",
        uid: "",
        fullname: "",
      },
    ],
  });
  const [lastProducts, setLastProducts] = useState([]);
  const [updater, setUpdater] = useState(true);
  const [hashtags, setHashtags] = useState();
  const [loader, setLoader] = useState(true);
  const Fspace = () => {
    let space;
    if (products.length > itemsPerPage) {
      let modPI = products.length % itemsPerPage;
      let rows = itemsPerPage / 4;
      let modPIR = modPI % rows;
      space = rows - modPIR;
    } else {
      let rows = itemsPerPage / 4;
      let modPR = products.length % rows;
      space = rows - modPR;
    }
    setSpace(space);
  };
  async function apihandler() {
    let shopSuffix = params.shop_suffix;
    let keyvalues = {
      shopSuffix,
    };
    let business = await connection("getshopinfo", keyvalues);
    if (business.status == 1) {
      let last = await connection("getlastproducts", keyvalues);
      let result = await connection("getproducttags", {
        shopSuffix: params.shop_suffix,
      });
      let tags = result.result;
      tags.sort((a, b) => b.tag_count - a.tag_count);
      setHashtags(
        tags.map((value) => ({
          ...value,
          selected: false,
        }))
      );
      setLastProducts(last.result);
      setBusiness(business.result);
      setBusinessC(business.result);
    } else if (business.status == -1) {
      setLoader(false);
      theAlert();
    }
  }
  let nav = useNavigate();
  function theAlert() {
    Swal.fire({
      title: "خطا!",
      text: "فروشگاهی با این آدرس موجود نمی باشد، لطفا آدرس سایت را چک کنید.",
      icon: "error",
      showCancelButton: false,
      confirmButtonColor: "#586ba6",
      confirmButtonText: "باشه",
    }).then((result) => {
      nav("/", {
        replace: true,
      });
    });
  }
  function tagHandler(id) {
    setHashtags(
      hashtags.map((value) => {
        if (value.id == id) {
          if (value.selected) {
            return {
              ...value,
              selected: false,
            };
          } else {
            return {
              ...value,
              selected: true,
            };
          }
        }
        return value;
      })
    );
  }
  async function getProducts() {
    setLoader(true);
    let tagIds = hashtags.reduce((total, value) => {
      if (value.selected) return [...total, value.id];
      return total;
    }, []);
    let result = await connection("getproducts", {
      shopSuffix: params.shop_suffix,
      tagIds: tagIds.join(","),
    });
    if (result.status == 1) {
      setProducts(result.result);
    }
    // setDelay((value) => value + 1);
    setLoader(false);
  }
  useEffect(() => {
    apihandler();
  }, []);
  useEffect(() => {
    if (hashtags) {
      getProducts();
    }
  }, [hashtags]);
  useEffect(() => {
    Fspace();
  }, [products]);
  let admin = auth.userInfo.shopIds.find((value) => value.id == bpid);

  return (
    <>
      {loader ? <Loader /> : ""}
      <>
        <div>
          <BusinessCover business={business} />
          {hashtags ? (
            <Hashtags hashtags={hashtags} tagHandler={tagHandler} />
          ) : (
            ""
          )}
          {products.length > 0 ? (
            <Formatter header={"جدیدترین محصولات"}>
              <Slider slider={lastProducts} products={products} />
            </Formatter>
          ) : (
            ""
          )}
          {admin ? (
            <div className="d-flex justify-content-end" style={{position:"relative"}} >
            <button data-bs-toggle="modal" data-bs-target="#addArticleModal"  style={{position:"absolute", top:'80%' , transform:"translate(50%, 130%)", outline:"none", border:"none", background:"#586ba6", color:"white", borderRadius:"12px", padding:"10px"}}>
            <MdOutlineAddShoppingCart style={{fontSize:"25px"}}/>
            </button>
            </div>
          ) : (
            ""
          )}
          <CreateProduct
            setLoader={setLoader}
            updater={updater}
            setUpdater={setUpdater}
          />
          {products.length > 0 ? (
            <Formatter header={"محصولات"}>
              {products.length > itemsPerPage ? (
                <PaginatedItems
                  itemsPerPage={itemsPerPage}
                  items={products}
                  TheComponent={Products}
                />
              ) : products.length != 0 ? (
                <Products items={products} />
              ) : (
                ""
              )}
            </Formatter>
          ) : (
            ""
          )}
        </div>
        {ReactDOM.createPortal(
          <>
            <SingleProduct
              setLoader={setLoader}
              updater={updater}
              setUpdater={setUpdater}
            />
            <ModalCustomerMessages />
            <ModalContact />
            <ModalShare />
            <ModalPoint />
            {/* <Container /> */}
            <Container beforeJoinClub={true} />
          </>,
          document.getElementById("modals")
        )}
      </>
    </>
  );
};

export default MainBusiness;
